<ng-container *ngIf="resultIsActive && (this.result !== undefined) && (this.result.resultID !== undefined) && (this.value !== undefined)">
	{{phase | translate}} / {{identifier | translate}} : {{formatValue() | translate}}
</ng-container>

<ng-container *ngIf="!resultIsActive && (this.result !== undefined) && (this.result.resultID !== undefined) && (this.value !== undefined)">
	{{phase | translate}} : {{formatValue() | translate}}
</ng-container>
